import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const ConditionalWrapper = ({ condition, Wrapper, children }) => (
  <Fragment>
    {condition ? Wrapper(children) : children}
  </Fragment>
);

ConditionalWrapper.propTypes = {
  condition: PropTypes.bool.isRequired,
  Wrapper: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default ConditionalWrapper;
